import PropTypes from 'prop-types'

import { useForm, useSetState } from '@domain-group/react-hooks'

import {
  Box, Button, FileInput, Form, SidebarModal,
} from '@domain-group/suit-theme'

import { isValidEmail } from '@domain-group/javascript-utils'

import useUser from '@hooks/useUser'

const defaultFormState = {
  email: '',
  fileData: null,
}

const customRequiredFields = [
  { key: 'email', validation: isValidEmail, invalidMessage: 'Invalid Email format' },
  { key: 'fileData' },
]

const handleSubmit = (importFn, entityState, callbacks, setState) => {
  const { closeModal, importUsers } = callbacks
  setState({ searching: true })

  const importUsersPayload = {
    callbacks: {
      action: importFn,
      afterAction: closeModal,
    },
    entityParams: entityState,
    toastText: 'User Import Queued',
  }

  importUsers(importUsersPayload).then(() => {
    setState({ searching: false })
  })
}

const defaultState = {
  searching: false,
}

const ImportUsersModal = (props) => {
  const { callbacks, modalKey, showModal } = props

  const [state, setState] = useSetState(defaultState)
  const { searching } = state

  const {
    callbacks: { importUsersCsv: importFn },
  } = useUser()

  const formPayload = useForm(defaultFormState, { requiredFields: customRequiredFields, validateOn: 'change' })

  const {
    entityState,
    errors,
    handlers,
    saveEnabled,
    setEntityState,
  } = formPayload

  return (
    <SidebarModal callbacks={callbacks} clickSafeZone modalKey={modalKey} showModal={showModal} size="small">
      <SidebarModal.Header callbacks={callbacks} title="Import" titleSecondLine="Users" />

      <SidebarModal.Content>
        <Box flexDirection="column">
          <Form.Field label="* CSV File">
            <FileInput
              input={{
                onChange: file => setEntityState({ fileData: file }),
                accept: '.csv',
              }}
            />
          </Form.Field>

          <Form.Field errorMessage={errors.email} label="* Email on Import Error" marginTop="large">
            <input name="email" type="email" {...handlers} />
          </Form.Field>
        </Box>
      </SidebarModal.Content>

      <SidebarModal.Footer>
        <Button
          buttonStyle="primaryCreate"
          disabled={!saveEnabled}
          loading={searching}
          onClick={() => handleSubmit(importFn, entityState, callbacks, setState)}
          size="large"
        >
          {saveEnabled ? 'Import Users' : 'Complete Fields'}
        </Button>
      </SidebarModal.Footer>
    </SidebarModal>
  )
}

ImportUsersModal.propTypes = {
  callbacks: PropTypes.object.isRequired,
  modalKey: PropTypes.string,
  showModal: PropTypes.bool,
}

ImportUsersModal.defaultProps = {
  modalKey: 'ImportUsersModal',
}

const LazyLoadedModal = props => (
  <SidebarModal.RenderController {...props}>
    <ImportUsersModal {...props} />
  </SidebarModal.RenderController>
)

export default LazyLoadedModal
